import { NextRouter } from 'next/router';

import { BookedCheck } from '@assets/icons/BookedCheck';
import theme from '@styles/theme';

// made these arrays in case more data needs to be added
// without breaking existing implementations

export const STATUS_CHECK_LABEL = 'Status Check';

type JobPage = 'booked' | 'invited' | 'availed';

export const AVAIL_CHECK_STATUS_TO_LABEL_MAP = {
  invited: 'Avail Check',
  submitted: 'Available',
  unavailable: 'Unavailable',
  released: 'Released',
  misc_message_list: 'Misc Message',
};

export const STATUS_CHECK_STATUS_TO_LABEL_MAP = {
  available_unconfirmed: STATUS_CHECK_LABEL,
  first_available: 'Avail Confirmed',
  released: 'Released',
  denied: 'Denied',
  misc_message_list: 'Misc Message',
};

export const BOOKINGS_STATUS_TO_LABEL_MAP = {
  booked: 'Booked',
  booked_confirmed: (
    <span style={{ display: 'flex' }}>
      Booked <BookedCheck />
    </span>
  ),
  canceled: 'Canceled',
  canceled_w_pay: 'Canceled w/ Pay',
  no_show: 'No Show',
  misc_message_bookings: 'Misc Message',
  released: 'Released',
};

const JOB_PAGE_TO_STATUS_MAP = {
  invited: Object.keys(AVAIL_CHECK_STATUS_TO_LABEL_MAP).concat(null),
  availed: Object.keys(STATUS_CHECK_STATUS_TO_LABEL_MAP),
  booked: Object.keys(BOOKINGS_STATUS_TO_LABEL_MAP),
};

export const checkJobPageStatus = (
  status: string,
  jobPage: JobPage,
  router: NextRouter
) => {
  if (JOB_PAGE_TO_STATUS_MAP[jobPage].includes(status)) {
    return;
  } else if (JOB_PAGE_TO_STATUS_MAP.invited.includes(status)) {
    router.push('/jobs/AvailChecks');
  } else if (JOB_PAGE_TO_STATUS_MAP.availed.includes(status)) {
    router.push('/jobs/StatusChecks');
  } else if (JOB_PAGE_TO_STATUS_MAP.booked.includes(status)) {
    router.push('/jobs/Bookings');
  }
};

export const FRONTEND_GENERATED_MESSAGE_TYPES = [
  'submitted',
  'unavailable',
  'available_confirmed',
  'denied',
  'no_show',
  'canceled',
];

export const BACKEND_GENERATED_MESSAGE_TYPES = [
  'invited',
  'available_unconfirmed',
  'released',
  'booked',
  'booked_confirmed',
  'misc_message_lists',
  'misc_message_bookings',
  'canceled_w_pay',
];

export const BOOKING_STATUS_FORMATTING = {
  available_unconfirmed: { backgroundColor: theme.palette.color[1] },
  first_available: { backgroundColor: theme.palette.color[2] },
  booked: { backgroundColor: theme.palette.primary[0] },
  booked_confirmed: {
    backgroundColor: theme.palette.primary[0],
    icon: BookedCheck,
  },
  released: { backgroundColor: theme.palette.greyscale[6] },
  canceled: { backgroundColor: theme.palette.color[0] },
  canceled_w_pay: { backgroundColor: theme.palette.color[0] },
  no_show: { backgroundColor: theme.palette.color[0] },
  denied: { backgroundColor: theme.palette.color[0] },
} as const;

export const BOOKING_STATUS_OPTIONS = [
  {
    text: STATUS_CHECK_LABEL,
    abbrev: STATUS_CHECK_LABEL,
    value: 'available_unconfirmed',
  },
  {
    text: 'Avail Conf.',
    abbrev: 'Avail Conf.',
    value: 'first_available',
  },
  { text: 'Booked', abbrev: 'Booked', value: 'booked' },
  {
    text: 'Booked \u2713',
    abbrev: 'Booked \u2713',
    value: 'booked_confirmed',
  },
  { text: 'Released', abbrev: 'Released', value: 'released' },
  {
    text: 'Canceled',
    abbrev: 'Canceled',
    value: 'canceled',
    ukText: 'Cancelled',
    ukAbbrev: 'Cancelled',
  },
  {
    text: 'Canceled w/ Pay',
    abbrev: 'Canceled w/ Pay',
    value: 'canceled_w_pay',
    ukText: 'Cancelled w/ Pay',
    ukAbbrev: 'Cancelled w/ Pay',
  },
  { text: 'No Show', abbrev: 'No Show', value: 'no_show' },
  { text: 'Denied', abbrev: 'Denied', value: 'denied' },
];
